<template>
  <div class="app-wrapper">
    <header class="top-header">
      <div class="header-brand">
        <div class="brand-mark">T</div>
        <div class="brand-info">
          <span class="brand-name">thxily</span>
          <span class="brand-sub">管理コンソール</span>
        </div>
      </div>
      <button class="back-btn" v-on:click="back">← メニューへ戻る</button>
    </header>
    <main class="main-content">
      <div class="white-card">
        <div class="page-head">
          <div>
            <p class="page-kicker">Team setup</p>
            <h1 class="page-title">チーム作成</h1>
            <p class="page-copy">
              システム内部で使う識別名と、画面表示に使う名称を分けて登録します。
              まずは運用しやすい命名ルールを揃えておくと管理しやすくなります。
            </p>
          </div>
          <div class="page-badge">
            <span class="page-badge__label">Mode</span>
            <span class="page-badge__value">Create</span>
          </div>
        </div>

        <form v-on:submit.prevent="create">
          <div class="section-card">
            <div class="section-head">
              <div>
                <p class="section-kicker">Team identity</p>
                <h2 class="section-title">基本設定</h2>
              </div>
            </div>

            <div class="field-grid field-grid--two">
              <div class="form-group">
                <label class="form-label">チーム名（正式名）</label>
                <input v-model="name" type="text" class="form-control" required placeholder="team_sales" />
              </div>

              <div class="form-group">
                <label class="form-label">チーム名（表示名）</label>
                <input v-model="display_name" type="text" class="form-control" required placeholder="営業部" />
              </div>
            </div>
          </div>

          <div class="section-card helper-card">
            <div class="section-head">
              <div>
                <p class="section-kicker">Guideline</p>
                <h2 class="section-title">命名の目安</h2>
              </div>
            </div>

            <ul class="summary-list">
              <li>正式名には部署やチームの正式な名称を入れます。</li>
              <li>表示名は一覧や画面上で見せる名称として使います。</li>
              <li>正式名と表示名を同じにしても問題ありません。</li>
            </ul>
          </div>

          <div class="form-actions">
            <button type="submit" class="btn-primary">作成</button>
            <button type="button" v-on:click="back" class="btn-secondary">戻る</button>
          </div>
        </form>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";
import store from "@/store";

export default {
  data: function () {
    return {
      name: "",
      display_name: "",
    }
  },
  async mounted() {
  },
  methods: {
    create: function () {
      const data = {
        id: "",
        name: this.name,
        display_name: this.display_name,
      }
      axios.post("/create_team", data).then((res) => {
        router.push("/teams")
      });
    },
    back: function () {
      router.push("/menu")
    },
    logout: function () {
      store.dispatch("logout")
    },
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap');

.app-wrapper {
  min-height: 100vh;
  background: #DDE2EC;
  font-family: 'Noto Sans JP', 'Segoe UI', sans-serif;
}

.top-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  height: 64px;
  background: #1E2A3A;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.header-brand { display: flex; align-items: center; gap: 12px; }

.brand-mark {
  width: 38px; height: 38px; border-radius: 10px;
  background: linear-gradient(135deg, #4F8EF7, #7C5CFC);
  display: flex; align-items: center; justify-content: center;
  font-size: 1.1rem; font-weight: 800; color: #fff;
}

.brand-info { display: flex; flex-direction: column; line-height: 1.2; }
.brand-name { font-size: 1rem; font-weight: 700; color: #fff; }
.brand-sub  { font-size: 0.68rem; color: #8A9BB0; }

.back-btn {
  padding: 8px 20px; border-radius: 8px;
  border: 1.5px solid #94A3B8; background: transparent;
  color: #94A3B8; font-size: 0.85rem; font-weight: 600;
  cursor: pointer; font-family: inherit;
  transition: background 0.2s, color 0.2s;
}
.back-btn:hover { background: #94A3B8; color: #1E2A3A; }

.main-content {
  max-width: 1080px; margin: 0 auto;
  padding: 40px 24px 80px;
}

.white-card {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 12px 30px rgba(15,23,42,0.08);
  padding: 32px 40px;
}

.page-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 28px;
  padding-bottom: 20px;
  border-bottom: 1px solid #E2E8F0;
}

.page-kicker {
  margin: 0 0 8px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #64748B;
}

.page-title {
  font-size: 1.55rem;
  font-weight: 700;
  color: #1E293B;
  margin: 0;
}

.page-copy {
  max-width: 58ch;
  margin: 12px 0 0;
  color: #64748B;
  font-size: 0.95rem;
  line-height: 1.8;
}

.page-badge {
  display: inline-flex;
  flex-direction: column;
  gap: 6px;
  min-width: 120px;
  padding: 12px 14px;
  border-radius: 14px;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
}

.page-badge__label {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748B;
}

.page-badge__value {
  font-size: 1rem;
  font-weight: 700;
  color: #0F172A;
}

.section-card {
  padding: 20px;
  border-radius: 18px;
  background: linear-gradient(180deg, #FFFFFF 0%, #F8FAFC 100%);
  border: 1px solid #E2E8F0;
  margin-bottom: 20px;
}

.section-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.section-kicker {
  margin: 0 0 6px;
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #64748B;
}

.section-title {
  margin: 0;
  font-size: 1.08rem;
  font-weight: 700;
  color: #1E293B;
}

.field-grid {
  display: grid;
  gap: 16px;
}

.field-grid--two {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.form-group { margin-bottom: 0; }
.form-label { display: block; font-size: 0.85rem; font-weight: 600; color: #475569; margin-bottom: 6px; }

.form-control {
  width: 100%;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1.5px solid #CBD5E1;
  font-size: 0.9rem;
  font-family: inherit;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.form-control:focus {
  border-color: #3B82F6;
  box-shadow: 0 0 0 4px rgba(59,130,246,0.12);
}

.summary-list {
  margin: 0;
  padding-left: 20px;
  color: #475569;
  line-height: 1.8;
  text-align: left;
}

.form-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  padding-top: 12px;
  border-top: 1px solid #E2E8F0;
  margin-top: 12px;
  justify-content: flex-end;
}

.btn-primary {
  padding: 10px 24px; border-radius: 12px; border: none;
  background: #3B82F6; color: #fff;
  font-size: 0.9rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: background 0.2s, transform 0.2s;
}
.btn-primary:hover { background: #2563EB; transform: translateY(-1px); }

.btn-secondary {
  padding: 10px 24px; border-radius: 12px;
  border: 1.5px solid #CBD5E1; background: #fff;
  color: #475569; font-size: 0.9rem; font-weight: 600;
  cursor: pointer; font-family: inherit; transition: background 0.2s, transform 0.2s;
}
.btn-secondary:hover { background: #F1F5F9; transform: translateY(-1px); }

@media (max-width: 900px) {
  .page-head,
  .field-grid--two {
    grid-template-columns: 1fr;
    flex-direction: column;
  }

  .page-badge {
    width: 100%;
  }
}

@media (max-width: 640px) {
  .top-header {
    padding: 0 16px;
  }

  .main-content {
    padding: 24px 14px 60px;
  }

  .white-card {
    padding: 22px 18px;
  }

  .section-card {
    padding: 16px;
  }

  .form-actions {
    justify-content: stretch;
  }

  .form-actions > * {
    width: 100%;
  }
}
</style>
